import { render, staticRenderFns } from "./permission_management.vue?vue&type=template&id=88814586&scoped=true"
import script from "./permission_management.vue?vue&type=script&lang=js"
export * from "./permission_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88814586",
  null
  
)

export default component.exports